import { render, staticRenderFns } from "./studentattendance.vue?vue&type=template&id=2480ca35&"
import script from "./studentattendance.vue?vue&type=script&lang=js&"
export * from "./studentattendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports